module.exports = __webpack_public_path__ + "img/index_4.66b77a99.jpg";